import {PAGES} from "../../../../../core/consts";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitorLinkParams} from "../../../models/competitor-link-params";

export class CompetitorNewsPageLinkModel extends BaseLinkModel  {
  constructor(competitorId, sportName, competitorName, isFollow: Boolean = true) {
    super(PAGES.COMPETITOR.news, new CompetitorLinkParams(competitorId, sportName, competitorName), false, null, null);

    this.isFollow = isFollow;
  }
}